import React, { useState } from 'react';
import styles from '../../Advisor.module.css';

const faqData = [
  {
    q: 'What kinds of advisors are available?',
    a: 'Bookkeepers, accountants, tax preparers, and financial advisors who specialize in small and independent businesses. We match you based on what you need.',
  },
  {
    q: 'Are advisors employed by Fyntiq?',
    a: 'No. Advisors are independent, vetted third-party professionals. Fyntiq makes the match and gives you a place to work together — the advice comes from them.',
  },
  {
    q: 'What does it cost?',
    a: "Pricing depends on the advisor and the type of help you need. You'll see rates before you book — no surprises.",
  },
  {
    q: 'Can they see my financial data?',
    a: 'Only what you choose to share. You grant access to specific Fyntiq records, control what\'s visible, and can revoke it any time.',
  },
  {
    q: 'Is this official tax or financial advice?',
    a: "Advice is provided by the independent professional you work with, under their own credentials and engagement — Fyntiq facilitates the connection but doesn't provide the advice itself.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={`${styles.container} ${styles.faqGrid}`}>
        <div className={`${styles.secHead} ${styles.sr}`} data-sr style={{ margin: 0 }}>
          <span className={styles.eyebrow}><span className={styles.dot} />FAQ</span>
          <h2 style={{ fontSize: 38 }}>Advisor questions.</h2>
        </div>
        <div className={styles.sr} data-sr>
          {faqData.map((item, i) => (
            <div key={item.q} className={`${styles.faqItem} ${openIndex === i ? styles.faqItemOpen : ''}`}>
              <div
                className={styles.faqQ}
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setOpenIndex(openIndex === i ? -1 : i)}
              >
                {item.q} <span className={styles.pm}>+</span>
              </div>
              <div className={styles.faqA}><p>{item.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
